/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabriele
 * File: datarefs.ts
 * Project: mle-client-n
 * Committed last: 2022/5/27 @ 1543
 * ---
 * Description:
 */

import { IDynamicDataRef } from '@revodigital/mpes';

export const UNIQUE_SEPARATOR = '_';

export interface DataRefGroup {
  originId: string;
  refs: IDynamicDataRef[];
}

/**
 * Divide le dataref  in base all'id della ricetta a cui puntano
 * @param refs
 */
export const splitPerDataOriginId = (refs: IDynamicDataRef[]): DataRefGroup[] => {
  let content: DataRefGroup[] = [];

  refs.forEach(it => {
    // Get groups that handle this id
    const withThisId = content.filter(c => c.originId === it.dataOriginId);
    if (withThisId.length > 0)
      withThisId[0].refs.push(it);
    else content.push({
      originId: it.dataOriginId,
      refs: [ it ]
    });
  });

  return content;
};

/**
 * Get the root item of a field path (root.item.nested)
 * @param fieldStr
 */
export const getFieldRootItem = (fieldStr: string): string => {
  if (!fieldStr) return '';

  const split = fieldStr.split(UNIQUE_SEPARATOR)[0] || '';
  return split;
};

export const getFieldItem = (fieldStr: string): string => {
  if (!fieldStr) return '';
  const index = fieldStr.indexOf(UNIQUE_SEPARATOR);

  if (index >= 0) {
    const item = fieldStr.substring(index + 1);
    return item;
  } else return fieldStr;
};
